(function () {
    'use strict';

    a3_cabin_reports.directive('campaigns', campaigns);

    /**
    * @memberof CabinReports
    * @ngdoc directive
    * @name campaigns
    * @restrict E
    * @description
    *   Implementation of issues
    *
    *   Initialize the campaigns template
    * @example
    *   Usage:
    *   <campaigns campaigns="campaigns"></campaigns>
    * @ngInject
    */
    function campaigns($uibModal, CampaignFactory) {

        function link(scope) {
            scope.currentTreatment = 0;
            scope.previousTreatment = previousTreatment;
            scope.nextTreatment = nextTreatment;
            scope.openAssignment = openAssignment;
            scope.FlightCampaigns = {};

            //Keeps modified accordion group open
            scope.status = { isItemOpen: new Array(scope.FlightCampaigns.length) };

            checkForCompletion();

            function openAssignment(assignment, flightId, campaign, treatment, cindex) {

                scope.status.isItemOpen[cindex] = true;

                var modalInstance = $uibModal.open({
                    templateUrl: 'views/Dialogs/dlgCampaignAssignment.html',
                    controller: 'AssignmentModalCtrl',
                    size: 'md',
                    keyboard: false,
                    resolve: {
                        assignment: function () {
                            return { ...assignment };
                        },
                        info: function () {
                            return { flightId: +flightId, campaign: campaign, treatment: treatment };
                        }
                    }
                });

                modalInstance.closed.then(function () {
                    scope.campaigns = CampaignFactory.getCampaignsByFlightId(+flightId);
                    checkForCompletion();
                });
            }

            function previousTreatment(index) {
                if (index > 0)
                    scope.currentTreatment = index - 1;
            }

            function nextTreatment(index, lenght) {
                if (index < lenght - 1)
                    scope.currentTreatment = index + 1;
            }

            function isOpen(index) {
                return latestOpen == index;
            }

            function checkForCompletion() {
                if (scope.campaigns && scope.campaigns.CampaignsList && scope.campaigns.CampaignsList.length > 0) {
                    scope.campaigns.CampaignsList.forEach(function (c) {
                        c.Treatments.forEach(function (t) {

                            var assignmentsWithStatus = t.Assignments.filter(function (a) { return +a.Status > 0 });
                            t.CompleteFeedbacksCount = assignmentsWithStatus.length;

                            var feedbacksCompleted = t.Assignments.every(function (a) {
                                return a.Status > 0;
                            });

                            if (feedbacksCompleted) {
                                t.FeedbacksCompleted = true;
                            } else {
                                t.FeedbacksCompleted = false;
                            }
                        });

                        var campaignCompleted = c.Treatments.every(function (t) {
                            return t.FeedbacksCompleted == true;
                        });

                        if (campaignCompleted) {
                            c.TreamentsCompleted = true;
                        } else {
                            c.TreamentsCompleted = false;
                        }
                    });

                    scope.FlightCampaigns = scope.campaigns;
                    scope.flight.hasPendingFeedbacks = CampaignFactory.hasPendingFeedbacks(scope.campaigns);
                }
            }
        }

        return {
            restrict: 'E',
            scope: {
                campaigns: '@'
            },
            terminal: true,
            templateUrl: 'views/directives/campaigns.tpl.html',
            scope: false,
            link: link
        }
    }
})();
